<template>
	<article class="block placeholder">
		<div class="block__avatar image is-48x48">
			<b-skeleton circle width="50px" height="50px"></b-skeleton>
		</div>
		<div class="block__content">
			<span class="block__name">
				<b-skeleton width="40%" height="15"></b-skeleton>
			</span>
			<span class="block__email">
				<b-skeleton width="75%" height="10"></b-skeleton>
			</span>
			<span class="block__email placeholder">
				<b-skeleton width="55%" height="7"></b-skeleton>
			</span>
		</div>
	</article>
</template>

<script>
export default {
	name: 'Placeholder'
}
</script>
